import React, { Component } from 'react';

class SimpleSliderTextil extends Component{
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state ={
      valueLeft:0,
      valueRight:0,
      leftLabel: this.props.white,
      rightLabel: this.props.colourful
    }
    this.transformed = false;
  }

  handleChange(e) {
    const value = e.target.value;
    this.props.onChange(value);
    this.setLabels(value)
  }

  setLabels = (value) => {
    if(value > 50 && this.state.rightLabel !== this.props.dark){
      this.setState({
        rightLabel: this.props.dark
      })
    }
    else if(value <= 50 && this.state.rightLabel !== this.props.colourful){
      this.setState({
        rightLabel: this.props.colourful
      })
    }
  }
  
  componentDidMount = () => {
    const value = this.props.defaultValue;
    this.props.onChange(value)
    this.setLabels(value)
  }

  componentDidUpdate = () => {
    this.setLabels(this.props.defaultValue)
  }

  render() {
    const styles = this.props.styles
    const icon = this.props.icon

    return(
      <div>
        <div className={styles.row}>
            <div className={styles.icon}>
              <img src={icon} alt="" />
            </div>
            <div className={styles.slider}>
              <aside className={styles.sliderData}>
                <span>{100 - this.props.defaultValue}{this.props.showPercentage && "%"}</span>
                <span>{this.props.defaultValue}{this.props.showPercentage && "%"}</span>
              </aside>
              <input onChange={this.handleChange} type="range"
                name={this.props.name}
                value={this.props.defaultValue}
                max="100"
                min="0"
                step="1"
              />
              <aside>
                <span>{this.props.white}</span>
                <span className={styles.bottom}>{this.props.label}</span>
                <span>{this.state.rightLabel}</span>
              </aside>
            </div>
          </div>
      </div>
      
    );
  }
}

export default SimpleSliderTextil;



// WEBPACK FOOTER //
// ./src/components/calculator/inputs/c_slider_textil.js